import { Alert } from 'antd';
import { AlertProps } from 'antd/lib/alert';
import React from 'react';

export default (props: AlertProps) => <Alert {...props} />;
